
import {WOW} from '../../../node_modules/wowjs/dist/wow';
new WOW().init();